import React, { useContext } from 'react'
import EditLeaguesAPI from '../components/Admin/LeaguesAPI/EditLeaguesAPI'
import LeaguesAPI from '../components/Admin/LeaguesAPI/LeaguesAPI'
import AddPlayerAPI from '../components/Admin/Player/AddPlayerAPI'
import AllPlayersAPI from '../components/Admin/Player/AllPlayersAPI'
import TopLeagues from '../components/Public/FootballAPI/League/TopLeagues'
import StateContext from '../StateContext'

function APIDashboardPage() {

    const appState = useContext(StateContext)

    return (
        <div className="container my-5">
            {appState.loggedIn && (
                <>
                    <AddPlayerAPI />
                    <AllPlayersAPI />
                    <LeaguesAPI />
                    <TopLeagues />
                    <EditLeaguesAPI />
                </>
            )}

        </div>
    )

}
export default APIDashboardPage